var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h2", [_vm._v("Add Marketing T&E Entry")]),
      _vm._v(" "),
      _c("time-expense-form", {
        attrs: { "is-unbound": false, "is-marketing": true }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3cb38a89", { render: render, staticRenderFns: staticRenderFns })
  }
}